import React, { HtmlHTMLAttributes } from "react";
import ReactSVG from "react-svg";
import clsx from "clsx";

import style from "./icon-component.module.scss";
import { Property } from "@node_modules/csstype";

export interface IIconComponentProps extends HtmlHTMLAttributes<HTMLSpanElement> {
  fillColor?: string;
  icon?: string;
  size: Property.Height;
  strokeColor?: string;
  strokeWidth?: string;
  className?: string;
}

const iconStyleClassName = (props: IIconComponentProps) => {
  const { fillColor, strokeColor, strokeWidth } = props;

  const defaultStyle = "icon-svg";
  const fillClassName = typeof fillColor !== "undefined" ? style[`${defaultStyle}--filled`] : "";
  const strokeWidthClassName = typeof strokeWidth !== "undefined" ? style[`${defaultStyle}--stroke-width`] : "";
  const outlineClassName = typeof strokeColor !== "undefined" ? style[`${defaultStyle}--outline`] : "";

  return clsx(style[defaultStyle], fillClassName, outlineClassName, strokeWidthClassName, props.className);
};

const component: React.FunctionComponent<IIconComponentProps> = (props) => {
  const { fillColor, strokeColor, strokeWidth, size, className, icon, ...spanProps } = props;

  if (typeof window === "undefined") {
    return (
      <span
        className={iconStyleClassName(props)}
        style={{
          fill: fillColor,
          height: size,
          stroke: strokeColor,
          strokeWidth,
          width: size
        }}
        {...spanProps}
      >
        <img src={icon} alt="" role="presentation" />
      </span>
    );
  }

  return (
    <ReactSVG
      suppressHydrationWarning
      src={icon || ""}
      renumerateIRIElements={true}
      wrapper="span"
      style={{
        fill: fillColor,
        height: size,
        stroke: strokeColor,
        strokeWidth,
        width: size
      }}
      className={iconStyleClassName(props)}
      {...spanProps}
    />
  );
};

const IconComponent = React.memo(component);

export { IconComponent };
